var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sign-page',{ref:"docHandlePage",attrs:{"title-text":"办公会议题征集处理","request":_vm.request,"table-size":"large","title-menus":[],"tableActions":_vm.tableActions,"column-list":_vm.columnList,"table-actions-fixed":true,"tableActionsWidth":100},on:{"tableAction":_vm.tableAction}})
}
var staticRenderFns = []

export { render, staticRenderFns }